// noinspection JSValidateTypes

import {
    Button,
    Form,
    InputGroup,
    ListGroup,
    Modal
} from "react-bootstrap";
import {useState} from "@hookstate/core";

import {getClient, getClientAddresses, getClientContacts, getClients} from "../../../../Services/ApiService";

import './ClientSelectModal.scss';
import AddressBlock from "./AddressBlock";
import ContactsBlock from "./ContactsBlock";

const blankAddress = {
        street: '',
        street2: '',
        city: '',
        state: '',
        zip: ''
    };

const blankContact = {
    name: '',
    phone: '',
    email: ''
};

function ClientSelectModal(props) {
    const showModal = useState(false);
    const clients = useState([{id: '', name: ''}]);
    const selectedClient = useState({
        id: '',
        name: '',
        isTaxExempt: false,
        salesman: '',
        addresses: [{
            street: '',
            street2: '',
            city: '',
            state: '',
            zip: ''
        }],
        contacts: [{
            name: '',
            phone: '',
            email: ''
        }]});
    const searchQuery = useState('');
    const searchResults = useState([]);
    const showClientList = useState(true);
    const isSearching = useState(false);
    const isRetrieving = useState(false);

    const jobValues = props.jobValues;

    function updateClients() {
        getClients(_clients => {
            clients.set(_clients);
            searchResults.set(_clients);
        });
    }

    const handleClose = () => showModal.set(false);
    const handleShow = () => {
        updateClients();
        searchQuery.set('');
        isSearching.set(false);
        showModal.set(true);
    }

    const handleOnSearchChange = e => {
        searchQuery.set(e.target.value);
        const query = e.target.value.toLowerCase();

        if (query === '') {
            isSearching.set(false);

            // it's ugly, but it's what the docs say to do
            // https://hookstate.js.org/docs/exceptions/#hookstate-102
            searchResults.set(JSON.parse(JSON.stringify(clients.get())));
        } else {
            isSearching.set(true);
            let results = clients.get().filter(client =>
                client.name.toLowerCase().includes(query)
            );

            searchResults.set(results);
        }
    }

    function selectClient(e) { // called when user selects a client from the list
        resetClientSpecifics();
        let clickedClient = clients.get().find(client => {
            return (client.id === e.target.value);
        });

        jobValues.clientId.set(clickedClient.id);
        jobValues.clientName.set(clickedClient.name);

        showClientList.set(false);

        selectedClient.id.set(clickedClient.id);
        selectedClient.name.set(clickedClient.name);
        selectedClient.salesman.set(clickedClient.salesman);

        jobValues.salesman.set(clickedClient.salesman);

        getClientAddresses(clickedClient.id, _addresses => {
            selectedClient.addresses.set(_addresses);
        });

        getClientContacts(clickedClient.id, _contacts => {
            selectedClient.contacts.set(_contacts);
        });

        getClient(clickedClient.id, _client => {
            selectedClient.isTaxExempt.set(_client[0].isTaxExempt === 1);
            props.isTaxExempt.set(_client[0].isTaxExempt);
        });
    }

    function resetClientSpecifics() {
        jobValues.clientName.set('');
        jobValues.clientId.set('');

        jobValues.shippingAddressStreet.set('');
        jobValues.shippingAddressStreet2.set('');
        jobValues.shippingAddressCity.set('');
        jobValues.shippingAddressState.set('');
        jobValues.shippingAddressZip.set('');

        jobValues.billingAddressStreet.set('');
        jobValues.billingAddressStreet2.set('');
        jobValues.billingAddressCity.set('');
        jobValues.billingAddressState.set('');
        jobValues.billingAddressZip.set('');

        jobValues.shippingContactName.set('');
        jobValues.shippingContactPhone.set('');
        jobValues.shippingContactEmail.set('');

        jobValues.billingContactName.set('');
        jobValues.billingContactPhone.set('');
        jobValues.billingContactEmail.set('');

        jobValues.salesman.set("");
    }

    function CreateNewClient() {
        return (
            <div>
                {/* Target _blank makes this open in a new tab */}
                <Button onClick={handleClose} variant={'link'} href={'/client/new'} target={'_blank'}>
                    Create New Client
                </Button>
                <p id={'newClientNewTab'}>(Opens in new tab)</p>
            </div>
        )
    }

    function handleClientDetailsBack() { // returns to list of clients
        resetClientSpecifics();
        showClientList.set(true);
        // noinspection JSCheckFunctionSignatures
        selectedClient.set({
            id: '',
            name: '',
            addresses: [{blankAddress}],
            contacts: [{blankContact}],
            salesman: ''
        });
    }

    function ClientList() { // displays list of clients
        if (isRetrieving.get()) {
            return (
                <div>
                    Loading...
                </div>
            )
        }

        if (clients.get().length === 0) {
            return <CreateNewClient />;
        }

        return(
            <div>
                {isSearching.get() &&
                    <div id={'searchResultsCount'}>
                        Found {searchResults.get().length} clients
                    </div>}
                <ListGroup id={'clientList'}>
                    <ListGroup.Item key={'newClient'}>
                        <CreateNewClient />
                    </ListGroup.Item>
                    {searchResults.get().map((client, idx) => {
                        return (
                            <ListGroup.Item key={idx}>
                                <Button variant={'link'} value={client.id} onClick={selectClient}>
                                    {client.name}
                                </Button>
                            </ListGroup.Item>
                        )
                    })}
                </ListGroup>
            </div>
        )
    }

    return (
        <div id={'clientSelectModalWrapper'}>
            <Button onClick={handleShow} id={'showClientSelectButton'}>Select Client Details</Button>

            <Modal show={showModal.get()} onHide={handleClose} scrollable={true} size={'lg'} id={'clientSelectModal'}>
                <Modal.Header>
                    <Modal.Title>Client Select</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div id={'clientSelection'} hidden={!showClientList.get()}>
                        <InputGroup id={'search'} className={'mb-3'}>
                            <InputGroup.Prepend>
                                <InputGroup.Text>Search</InputGroup.Text>
                            </InputGroup.Prepend>
                            <Form.Control
                                id={'clientSearchInput'}
                                name={'clientSearchInput'}
                                autoComplete={'off'}
                                onChange={handleOnSearchChange}
                                value={searchQuery.get()}
                                placeholder={'Client Name'}
                            />
                        </InputGroup>
                        <ClientList />
                    </div>
                    {selectedClient.id.get() !== '' &&
                        <div id={'clientDetails'}>
                            <div id={'head'}>
                                <Button onClick={handleClientDetailsBack}>Back</Button>
                                <h4 id={'clientName'}>{selectedClient.name.get()}</h4>
                                <p>Salesman: {selectedClient.get().salesman}</p>
                                <Form.Check checked={selectedClient.get().isTaxExempt} label={"Client is Tax Exempt"} disabled />
                            </div>
                            <hr/>
                            <AddressBlock selectedClient={selectedClient} jobValues={jobValues} /><br/>

                            <ContactsBlock selectedClient={selectedClient} jobValues={jobValues} />
                        </div>
                    }
                </Modal.Body>
                <Modal.Footer>
                    <Button variant={"primary"} onClick={handleClose}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default ClientSelectModal;